import React, { PureComponent } from 'react';

import Icon from '~/core/scripts/components/Icon';
import { is640Query } from '~/core/scripts/mediaquery-helper';

const items = [
  { label: 'Einzeltier', color: '#007369', key: 'Einzelwolf' },
  { label: 'Paar', color: '#74B03F', key: 'Paar' },
  { label: 'Rudel', color: '#FFDD45', key: 'Rudel' },
];

const isSmallScreen = !is640Query();

function getLabel(label, count) {
  if (!isSmallScreen) {
    return label;
  }

  if (label === 'Rudel' || count === 1) {
    return label;
  }

  return `${label}e`;
}

class Legend extends PureComponent {
  render() {
    if (!this.props.areas) {
      return null;
    }

    const currentData = this.props.areas
      .map(d => d.data)
      .reduce((res, item) => res.concat(...item), [])
      .filter(d => d.year === this.props.currentYear)
      .reduce((res, item) => {
        if (item['Extra-Marker'] === '') {
          res[item.Status]++;
        }

        return res;
      }, {
        Einzelwolf: 0,
        Paar: 0,
        Rudel: 0
      });

    return (
      <div className="legend">
        <div className="legend__title">Wolfsterritorien</div>
        <div className="legend__items">
          {items.map(d => (
            <div
              key={`legend__${d.label}`}
              className="legend__item"
            >
              <div className="legend__item-icon"><Icon type={d.label.toLowerCase()} /></div>
              <div className="legend__item-box" style={{ backgroundColor: d.color }}></div>
              <div className="legend__item-label">{isSmallScreen ? <strong>{currentData[d.key]}</strong> : '' } {getLabel(d.label, currentData[d.key])}</div>
              {!isSmallScreen && <div className="legend__item-number">{currentData[d.key]}</div>}
            </div>
          ))}
          <div className="legend__item special sichtungen">
            <div className="legend__item-box"></div>
            <div className="legend__item-label">Wolf-Sichtungen</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Legend;
